import React from 'react';
import DriversTable from './DriversTable';

export default function AutoCalculateDelayedEarningsDrivers() {
  return (
    <DriversTable title="Auto-calculate delayed earnings" orderByChild="autoCalculateDelayedEarnings" equalTo={true} />
  );
}
